interface IAddPolylineOptions {
  map: google.maps.Map;
  path: { lat: number; lng: number }[];
}

export const addPolyline = ({ map, path }: IAddPolylineOptions): google.maps.Polyline => {
  const lineSymbol = {
    path: google.maps.SymbolPath.CIRCLE,
  };

  return new google.maps.Polyline({
    map,
    path,
    icons: [
      {
        icon: lineSymbol,
        offset: '100%',
      },
    ],
    strokeOpacity: 1.0,
    strokeWeight: 2,
  });
};
